import { salesPersonConstants } from "../constants/salesPersonConstants";

const initialState = {
  sending: false,
  error: {},
  salesPersonList: {},
  accessResponse: {},
  salesPersoncities: {},
  salesPersonaccess: {},
  questionList: {},
  reportData: {},
  citiesReportData: {},
  quesdetail: {},
  answerResponse: {},
  exportReport: {},
  helpdetail: {},
  replyResponse: {},
  helpResponse: {},
  monthyear: {},
  progressData: {}
};

export default function salesPersonReducer(state = initialState, action) {
  switch (action.type) {
    case salesPersonConstants.GET_SALESMANAGER_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_SALESMANAGER_SUCCESS:
      return {
        ...state,
        salesPersonList: action.data
      };
    case salesPersonConstants.GET_SALESMANAGER_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.ADD_CITY_ACCESS_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.ADD_CITY_ACCESS_SUCCESS:
      return {
        ...state,
        accessResponse: action.data
      };
    case salesPersonConstants.ADD_CITY_ACCESS_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_SALESMANAGER_CITIES_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_SALESMANAGER_CITIES_SUCCESS:
      return {
        ...state,
        salesPersoncities: action.data
      };
    case salesPersonConstants.GET_SALESMANAGER_CITIES_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.PROMOTE_SALESPERSON_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.PROMOTE_SALESPERSON_SUCCESS:
      return {
        ...state,
        salesPersonaccess: action.data
      };
    case salesPersonConstants.PROMOTE_SALESPERSON_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_SALESMANAGER_QUESTIONS_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_SALESMANAGER_QUESTIONS_SUCCESS:
      return {
        ...state,
        questionList: action.data
      };
    case salesPersonConstants.GET_SALESMANAGER_QUESTIONS_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_SALESMANAGER_REPORT_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_SALESMANAGER_REPORT_SUCCESS:
      return {
        ...state,
        reportData: action.data
      };
    case salesPersonConstants.GET_SALESMANAGER_REPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_CITIES_REPORT_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_CITIES_REPORT_SUCCESS:
      return {
        ...state,
        citiesReportData: action.data
      };
    case salesPersonConstants.GET_CITIES_REPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_SALESMANAGER_QUESDETAIL_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_SALESMANAGER_QUESDETAIL_SUCCESS:
      return {
        ...state,
        quesdetail: action.data
      };
    case salesPersonConstants.GET_SALESMANAGER_QUESDETAIL_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.UPDATE_ANSWER_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.UPDATE_ANSWER_SUCCESS:
      return {
        ...state,
        answerResponse: action.data
      };
    case salesPersonConstants.UPDATE_ANSWER_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_SALESMANAGER_EXPORT_REPORT_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_SALESMANAGER_EXPORT_REPORT_SUCCESS:
      return {
        ...state,
        exportReport: action.data
      };
    case salesPersonConstants.GET_SALESMANAGER_EXPORT_REPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_HELP_DETAIL_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_HELP_DETAIL_SUCCESS:
      return {
        ...state,
        helpdetail: action.data
      };
    case salesPersonConstants.GET_HELP_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.ADD_HELP_QUESTION_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.ADD_HELP_QUESTION_SUCCESS:
      return {
        ...state,
        helpResponse: action.data
      };
    case salesPersonConstants.ADD_HELP_QUESTION_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.ADD_HELP_REPLY_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.ADD_HELP_REPLY_SUCCESS:
      return {
        ...state,
        replyResponse: action.data
      };
    case salesPersonConstants.ADD_HELP_REPLY_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case salesPersonConstants.GET_MONTH_YEAR_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_MONTH_YEAR_SUCCESS:
      return {
        ...state,
        monthyear: action.data
      };
    case salesPersonConstants.GET_MONTH_YEAR_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case salesPersonConstants.GET_PROGRESS_REPORT_REQUEST:
      return {
        sending: true
      };
    case salesPersonConstants.GET_PROGRESS_REPORT_SUCCESS:
      return {
        ...state,
        progressData: action.data
      };
    case salesPersonConstants.GET_PROGRESS_REPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/salesPersonReducer.js